/* unplugin-vue-components disabled */import _objectSpread from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { mapState, mapActions } from 'vuex';
export default {
  name: 'iHeaderFullscreen',
  computed: _objectSpread({}, mapState('admin/layout', ['isFullscreen'])),
  methods: _objectSpread({}, mapActions('admin/layout', ['toggleFullscreen']))
};